export type CategoryKey = 'forza' | 'salto' | 'velocita' | 'resistenza' | 'mobilita' | 'composizione' | 'rtp_rts';
export type TimeframeKey = '1m' | '3m' | '6m' | 'season' | 'all';

export const categoryLabels: Record<CategoryKey, string> = {
  forza: 'Forza',
  salto: 'Salto',
  velocita: 'Velocità',
  resistenza: 'Resistenza',
  mobilita: 'Mobilità',
  composizione: 'Composizione',
  rtp_rts: 'RTP/RTS',
};

export const timeframeLabels: Record<TimeframeKey, string> = {
  '1m': '1 Mese',
  '3m': '3 Mesi',
  '6m': '6 Mesi',
  'season': 'Stagione',
  'all': 'Tutto',
};

export const athleteColors: Record<string, string> = {
  '1': '#013344',
  '2': '#27ae60',
  '3': '#5BC9E0',
  '4': '#FFD15A',
  '5': '#f57c73',
  '6': '#9b59b6',
  '7': '#e67e22',
  '8': '#34495e',
};

export interface TeamUser {
  _id: string;
  firstName: string;
  lastName: string;
  type?: string;
  /** Ruoli dello sport (es. ['Portiere', 'Difensore']) — dal campo roles di IAthlete */
  roles?: string[];
  /** Posizione singola dell'atleta (chiave unica, sostituisce il vecchio campo `role`) */
  position?: string;
}

/** Atleta usato nelle viste analitiche testing */
export type Athlete = {
  id: string;
  name: string;
  /** Prima posizione/ruolo dell'atleta — usata per la vista "Per ruolo" (sez.8) */
  position?: string;
};
